export default `/* Ids Theme Switcher Css */
:host {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-self: center;
  padding: 0 var(--ids-space-3xs);
}

:host([hidden]) {
  display: none;
}

#ids-theme-switcher {
  z-index: var(--ids-z-index-0);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdGhlbWUtc3dpdGNoZXIiLCJzb3VyY2VzIjpbImlkcy10aGVtZS1zd2l0Y2hlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBRUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIFRoZW1lIFN3aXRjaGVyIENzcyAqL1xuXG46aG9zdCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gIGFsaWduLXNlbGY6IGNlbnRlcjtcbiAgcGFkZGluZzogMCB2YXIoLS1pZHMtc3BhY2UtM3hzKTtcbn1cblxuOmhvc3QoW2hpZGRlbl0pIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuI2lkcy10aGVtZS1zd2l0Y2hlciB7XG4gIHotaW5kZXg6IHZhcigtLWlkcy16LWluZGV4LTApO1xufSJdfQ== */`;
